export default {
    get: function () {
        const menu = [
            userGuideDataAnalysisFAQ,
            userGuideCrossTabulation,
            userGuideLogisticRegression,
            userGuideVariables
        ];
        const other = [];

        return {
            public: {
                name: 'userGuide',
                menu,
                other,
                index
            }
        }
    }
}

// const userGuideOverview = {
//     name: 'userGuideOverview',
//     url: '/userGuide/overview',
//     title: "User Guide Overview",
//     description: 'Get an overview of what WEAT is and how to use it'
// };

const userGuideDataAnalysisFAQ = {
    showOnIndexPage: false,
    name: 'userGuideDataAnalysisFAQ',
    url: '/userGuide/dataAnalysisFaq',
    title: "Data Analysis FAQ",
    description:
        'General information on data analysis'
};

const userGuideCrossTabulation = {
    name: 'userGuideCrossTabulation',
    url: '/userGuide/crossTabulation',
    title: "Cross Tabulation User Guide",
    description: 'Get help on how to run a Cross Tabulation'
};

const userGuideLogisticRegression = {
    showOnIndexPage: false,
    name: 'userGuideLogisticRegression',
    url: '/userGuide/logisticRegression',
    title: "Logistic Regression User Guide",
    description: 'Get help on how to run a Logistic Regression'
};

const userGuideVariables = {
    showOnIndexPage: false,
    name: 'userGuideVariables',
    url: '/userGuide/variables',
    title: "Independent, Dependent and Control Variables",
    description: 'Find out what each type of variable is'
}

const index = {
    groupName: 'userGuide', //
    name: 'userGuide',
    url: '/help', //
    title: "User Guide", //
    isGroup: true
};
